import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=3ff72842&"
import script from "./organization.vue?vue&type=script&lang=js&"
export * from "./organization.vue?vue&type=script&lang=js&"
import style0 from "./organization.vue?vue&type=style&index=0&id=3ff72842&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports